import { FC } from "react";

const HowToLearnProductCardSkeleton: FC = () => {
  return (
    <div className="md:p-4 md:pl-2 py-2 px-2.5 relative items-start w-full rounded-8 border border-fds-default animate-pulse">
      <div className="flex gap-2 md:gap-x-4 items-start md:items-center">
        <div className="rounded-6 grow shrink-0 relative lg:w-[174px] md:w-[146px] w-[95px] md:h-[86px] h-[63px] lg:h-[116px] overflow-hidden bg-fds-disable">
          <div className="bg-[#FFFFFF66] z-[5] rounded-4 absolute right-1 top-1 lg:h-10 lg:w-10 h-8 w-8" />
        </div>

        <div className="w-full">
          <div className="flex items-start justify-between gap-2 pl-2">
            <div className="min-h-10 md:min-h-full lg:min-h-fds-52 w-full">
              <div className="h-4 md:h-5 w-full max-w-[90%] bg-fds-disable rounded" />
              <div className="h-4 md:h-5 w-2/3 mt-1 bg-fds-disable rounded md:hidden lg:block" />
            </div>
          </div>

          <div className="md:min-h-14 lg:mt-2 mt-1.5">
            <div className="rounded-full lg:mb-2 md:mb-1.5 mb-1 h-5 md:w-[76px] w-[63px] bg-fds-disable" />

            <div className="flex gap-x-3 md:flex-row md:items-center md:h-7 flex-col gap-y-1">
              <div className="items-center flex gap-x-1">
                <div className="md:w-5 md:h-5 h-4 w-4 rounded bg-fds-disable" />
                <div className="h-2.5 md:h-3.5 w-16 md:w-20 bg-fds-disable rounded" />
              </div>
              <div className="h-4 md:block hidden bg-fds-disable w-px mx-2" />
              <div className="items-center flex gap-x-1">
                <div className="md:w-5 md:h-5 h-4 w-4 rounded bg-fds-disable" />
                <div className="h-2.5 md:h-3.5 w-14 md:w-16 bg-fds-disable rounded" />
              </div>
              <div className="self-end pt-2 mr-auto hidden md:block w-10 h-10 bg-fds-disable rounded" />
            </div>
          </div>
        </div>
      </div>

      <div className="absolute flex md:hidden left-0 bottom-0 py-2">
        <div className="w-8 h-8 bg-fds-disable rounded" />
      </div>
    </div>
  );
};

export default HowToLearnProductCardSkeleton;
